export default __webpack_public_path__ + "static/media/app_icon.a56f4198.svg";